<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div class="flex min-w-0 flex-grow flex-col">

            <div class="flex-grow" [class.mce-form-field-disabled]="primaryMethodsRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>primary method</mat-label>
                    <mat-select [formField]="form().installation.bs7671Factors.primaryMethodGuid">
                        @for (option of primaryMethods(); track option.value) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex-grow" [class.mce-form-field-disabled]="secondaryMethodsRx.isLoading()">
                <mat-form-field class="w-full">
                    <mat-label>secondary method</mat-label>
                    <mat-select [formField]="form().installation.bs7671Factors.secondaryMethodGuid">
                        @for (option of secondaryMethods(); track option.value) {
                        <mat-option [value]="option.value">{{option.label}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

        </div>

        @if(viewState().hasInstallationImage){
        <div class="hidden sm:flex">
            <app-form-image [formImage]="viewState().installationImage"></app-form-image>
        </div>  }

    </div>

    <div class="mce-form-field-group">
        <app-grouping [form]="form().installation.bs7671Factors.grouping"></app-grouping>
    </div>

    <div class="mce-form-field-group">

        @if(isBuried()) {
        <app-buried [form]="form().installation.bs7671Factors.buried"></app-buried>
        }

        <app-ambient-temperature [form]="form().installation.bs7671Factors.ambientTemperature" [isBuried]="isBuried()"></app-ambient-temperature>


        @if(isThermallyInsulatedWall()) {
        <div>
            <mat-form-field>
                <mat-label>thermal insulation thickness</mat-label>
                <input matInput type="number" placeholder="thermal insulation thickness"
                       [formField]="form().installation.bs7671Factors.thermalInsulationThickness" />
                <span matSuffix>mm</span>
                @for (error of form().installation.bs7671Factors.thermalInsulationThickness().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }


    </div>


        <div class="mce-form-field-group">
            <app-user-defined-factor [form]="form().installation.bs7671Factors.userDefinedFactor"></app-user-defined-factor>
        </div>



</form>
